import { render, staticRenderFns } from "./RotateImageCkyc.vue?vue&type=template&id=5d82a8e6&scoped=true&"
import script from "./RotateImageCkyc.vue?vue&type=script&lang=js&"
export * from "./RotateImageCkyc.vue?vue&type=script&lang=js&"
import style0 from "./RotateImageCkyc.vue?vue&type=style&index=0&id=5d82a8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82a8e6",
  null
  
)

export default component.exports